// extracted by css-extract-rspack-plugin
export default {"root":"TAtGX","withName":"d_QHE"};